export enum ExportFormat {
  FXL = 'fxl',
  JSON = 'json',
}

export type ExportSyncDraftApiRequest = {
  format?: ExportFormat;
  domainIds?: number[];
  contractIds?: number[];
  topLevelNodeIds?: number[];
};
